module.exports = __webpack_public_path__ + "img/Metastasis-GBM_10X_TPCP.cb810fd2.png";